import React from 'react';
import {useTransfersContext} from "../TransfersContext";
import {FormattedMessage} from "react-intl";
import styles from './Notes.module.scss';

const Notes = () => {
  const {fileExists, year} = useTransfersContext();

  return !fileExists ? (
    <div className={styles.noteContainer}>
      <div className={styles.label}>
        <FormattedMessage
          id={'transfers-warning-label'}
          defaultMessage={'Form 101 not completed for {year}'}
          values={{year}}
        />
      </div>
    </div>
  ) : null
};

export default Notes;
